import { t as i } from "./isDefined-fMi6eQ4r.js";
import { n as L, o as M } from "./utilities-D50JxcQi.js";
import { t as D } from "./Loader-BiThG84i.js";
import { t as K } from "./Pill-DaFEFIOT.js";
import { t as m } from "./mergeClassNames-BHKm1BNi.js";
import { clsx as u } from "clsx";
import { jsx as a, jsxs as _ } from "react/jsx-runtime";
import { createContext as C, useContext as $ } from "react";
import { Button as O } from "@base-ui/react/button";
import { Radio as S } from "@base-ui/react/radio";
import { Input as T } from "@base-ui/react/input";
import { Switch as w } from "@base-ui/react/switch";
var V = "_hotkeys_16heq_1", g = { hotkeys: V }, A = ({ hotkeys: o }) => /* @__PURE__ */ a("span", {
  className: g.hotkeys,
  "aria-hidden": !0,
  children: o.join(M())
}), E = "_soonPillContainer_e7hkk_1", F = { soonPillContainer: E }, J = ({ label: o = "Soon" }) => /* @__PURE__ */ a("span", {
  className: F.soonPillContainer,
  children: /* @__PURE__ */ a(K, { label: o })
}), Q = C(null), U = "_button_xts30_1", W = "_content_xts30_161", X = "_label_xts30_170", Y = "_icon_xts30_176", Z = "_hidden_xts30_186", aa = "_loader_xts30_190", n = {
  button: U,
  content: W,
  label: X,
  icon: Y,
  hidden: Z,
  loader: aa
}, ya = ({ variant: o = "outline", color: r = "neutral", size: e = "md", fullWidth: t = !1, loading: s = !1, elevated: y = !1, startIcon: f, endIcon: b, hotkeys: N, soon: k = !1, soonLabel: P, disabled: z = !1, href: c, render: R, className: q, children: v, ...x }) => {
  const h = $(Q), G = h?.variant ?? o, I = h?.color ?? r, j = h?.size ?? e, H = L(), l = i(c);
  return /* @__PURE__ */ _(O, {
    ...x,
    ...l ? { href: c } : void 0,
    className: m(n.button, q),
    "data-variant": G,
    "data-color": I,
    "data-size": j,
    "data-full-width": t || void 0,
    "data-loading": s || void 0,
    "data-elevated": y || void 0,
    "aria-busy": s ? "true" : x["aria-busy"],
    disabled: z || k || s,
    role: l ? "link" : void 0,
    nativeButton: !l,
    render: R ?? (l ? /* @__PURE__ */ a("a", {
      href: c,
      children: v
    }) : void 0),
    children: [/* @__PURE__ */ _("span", {
      className: u(n.content, s && n.hidden),
      children: [
        i(f) && /* @__PURE__ */ a("span", {
          className: n.icon,
          "aria-hidden": !0,
          children: f
        }),
        i(v) && /* @__PURE__ */ a("span", {
          className: n.label,
          children: v
        }),
        i(b) && /* @__PURE__ */ a("span", {
          className: n.icon,
          "aria-hidden": !0,
          children: b
        }),
        i(N) && !H && /* @__PURE__ */ a(A, { hotkeys: N }),
        k && /* @__PURE__ */ a(J, { label: P })
      ]
    }), s && /* @__PURE__ */ a("span", {
      className: n.loader,
      "aria-hidden": !0,
      children: /* @__PURE__ */ a(D, {})
    })]
  });
}, oa = "_root_ahkrw_1", ta = "_control_ahkrw_18", ra = "_sm_ahkrw_33", ea = "_md_ahkrw_38", sa = "_indicator_ahkrw_49", d = {
  root: oa,
  control: ta,
  sm: ra,
  md: ea,
  indicator: sa
}, Pa = ({ children: o, className: r, size: e = "sm", ...t }) => /* @__PURE__ */ _(S.Root, {
  ...t,
  className: m(u(d.root, d[e]), r),
  children: [/* @__PURE__ */ a("span", {
    className: d.control,
    "aria-hidden": !0,
    children: /* @__PURE__ */ a(S.Indicator, { className: d.indicator })
  }), o]
}), na = "_root_1h4bi_1", ia = "_sm_1h4bi_33", la = "_md_1h4bi_39", da = "_thumb_1h4bi_45", p = {
  root: na,
  sm: ia,
  md: la,
  thumb: da
}, za = ({ size: o = "md", className: r, children: e, ...t }) => /* @__PURE__ */ _(w.Root, {
  ...t,
  className: m(u(p.root, p[o]), r),
  children: [/* @__PURE__ */ a(w.Thumb, { className: p.thumb }), e]
}), _a = C(null), ma = "_input_1u1eq_1", ua = "_sm_1u1eq_45", ca = "_md_1u1eq_49", B = {
  input: ma,
  sm: ua,
  md: ca
}, Ra = ({ size: o, className: r, ...e }) => {
  const t = $(_a), s = o ?? t?.size ?? "md";
  return /* @__PURE__ */ a(T, {
    ...e,
    className: m(u(B.input, B[s]), r),
    "data-grouped": i(t) || void 0
  });
};
export {
  Pa as a,
  za as i,
  B as n,
  ya as o,
  _a as r,
  Q as s,
  Ra as t
};
